<template>
  <el-image
      style="width: 80px; height: 80px"
      :src="images.smallHeadImg"
      @click="showImg(images.headImg)"
      class="cursor"
  >
  <template #error><div class="el-img-error">暂无图片</div></template></el-image>
</template>

<script>
import ImgViewer from "@/assets/js/imageViewer";

export default {
name: "HeadImg",
  props: {
    images: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  methods: {
    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },
  }
}
</script>

<style scoped>

</style>
